import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useVociPortale } from '../utils/vociPortale';
import useTicketDaLeggere from '../utils/useTicketDaLeggere';
import { LogOut } from 'lucide-react';
import { useVociPortaleOrdinate } from './menuPortale';
import api from '../api/client';

export default function SidebarAllenatore({ mobile, onClose }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const voci = useVociPortale();
  const ticketDaLeggere = useTicketDaLeggere(voci.attivaPath('/cliente/tickets', user));
  const [contrattiDaConfermare, setContrattiDaConfermare] = useState(0);
  // Voci, ordine e nomi in menuPortale.js (riordinabili da ROOT in Impostazioni → Menu laterale)
  const vociMenu = useVociPortaleOrdinate('ALLENATORE');
  const badge = { '/allenatore/contratti': contrattiDaConfermare, '/cliente/tickets': ticketDaLeggere };

  useEffect(() => {
    api.get('/dipendenti/me/contratti')
      .then(r => setContrattiDaConfermare(r.data.filter(c => c.stato !== 'FIRMATO').length))
      .catch(() => {});
  }, []);

  const isActive = (path) => location.pathname === path || (path === '/cliente/fipav' && location.pathname.startsWith('/cliente/fipav/'));

  return (
    <div className="app-sidebar" style={mobile ? { ...s.sidebar, height:'100vh', minHeight:0, overflowY:'auto', zIndex:1001, boxShadow:'0 10px 40px rgba(0,0,0,.45)' } : s.sidebar}>
      <div style={s.logoWrap} onClick={() => navigate('/allenatore')}>
        <img src="/logo.png" alt="B-Cheers ASD" style={s.logo} onError={e => { e.target.style.display='none'; }}/>
        <div style={{ fontFamily:"'Barlow Condensed'", fontSize: 'var(--font-size-lg)', fontWeight:'800', color:'#F4600C', letterSpacing:'2px' }}>B-CHEERS ASD</div>
      </div>
      <div style={s.divider}/>

      <nav style={s.nav}>
        {vociMenu.filter(({ path, hideIfSocio }) => !(hideIfSocio && user?.is_socio) && voci.attivaPath(path, user)).map(({ path, label, icon: Icon, hideIfSocio }) => { const accent = hideIfSocio ? '#F59E0B' : null; const n = badge[path]; return (
          <React.Fragment key={path}>
          <button style={{ ...s.navItem, ...(isActive(path) ? s.navActive : {}) }}
            onClick={() => navigate(path)}>
            <Icon size={15} color={isActive(path) ? '#F4600C' : (accent || '#555')}/>
            <span style={{ ...s.navLabel, color: isActive(path) ? '#fff' : (accent || '#777') }}>{label}</span>
            {!!n && (
              <span style={{ fontSize:'9px', fontWeight:'700', color:'#fff', background:'#EF4444', borderRadius:'8px', padding:'1px 6px', marginRight:'4px' }}>{n}</span>
            )}
            {isActive(path) && <div style={s.activeBar}/>}
          </button>
          </React.Fragment>
        ); })}
      </nav>

      <div style={{ marginTop:'auto' }}>
        <div style={s.divider}/>
        <div style={{ display:'flex', alignItems:'center', gap:'10px', padding:'14px 16px' }}>
          <div style={{ width:'32px', height:'32px', background:'#F4600C20', border:'1px solid #F4600C30', borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', fontSize: 'var(--font-size-sm)', fontWeight:'700', color:'#F4600C', flexShrink:0 }}>
            {user?.nome?.[0] || 'A'}
          </div>
          <div style={{ flex:1, minWidth:0 }}>
            <div style={{ fontSize: 'var(--font-size-xs)', fontWeight:'600', color:'var(--text)', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{user?.nome}</div>
            <div style={{ fontSize: 'var(--font-size-xs)', color:'#555', fontWeight:'700' }}>ALLENATORE</div>
          </div>
        </div>
        <button style={s.logoutBtn} onClick={() => { logout(); navigate('/login'); }}>
          <LogOut size={13} color="#555"/> ESCI
        </button>
      </div>
    </div>
  );
}

const s = {
  sidebar:   { width:'220px', minHeight:'100vh', background:'var(--bg-sidebar)', borderRight:'1px solid var(--border)', display:'flex', flexDirection:'column', position:'fixed', top:0, left:0, zIndex:100 },
  logoWrap:  { padding:'18px 16px', cursor:'pointer', display:'flex', alignItems:'center', gap:'10px' },
  logo:      { width:'32px', height:'32px', objectFit:'contain', filter:'brightness(0) invert(1)' },
  divider:   { height:'1px', background:'var(--bg-input)', margin:'0 12px' },
  nav:       { padding:'12px 8px', display:'flex', flexDirection:'column', gap:'2px', flex:1 },
  navItem:   { display:'flex', alignItems:'center', gap:'9px', padding:'9px 12px', borderRadius:'7px', border:'none', background:'transparent', cursor:'pointer', position:'relative', width:'100%', textAlign:'left' },
  navActive: { background:'var(--bg-input)' },
  navLabel:  { fontSize: 'var(--font-size-xs)', fontWeight:'700', letterSpacing:'0.5px', flex:1 },
  activeBar: { position:'absolute', right:0, top:'50%', transform:'translateY(-50%)', width:'3px', height:'18px', background:'#F4600C', borderRadius:'2px' },
  logoutBtn: { display:'flex', alignItems:'center', gap:'8px', padding:'10px 16px', background:'transparent', border:'none', cursor:'pointer', width:'100%', fontSize: 'var(--font-size-xs)', letterSpacing:'1px', color:'#555', fontWeight:'700', marginBottom:'8px' },
};
